import React, { useState } from "react";
import { Button, Paper, Typography, Box } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

import WebChatList from "../WebChatList";
import WebChatConfigModal from "../WebChatConfigModal";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  paper: {
    padding: theme.spacing(2),
  },
}));

const WebChatSettings = () => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedWebChat, setSelectedWebChat] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleOpenModal = (webChat = null) => {
    setSelectedWebChat(webChat);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedWebChat(null);
    setModalOpen(false);
  };

  const handleSave = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className={classes.root}>
      <Box className={classes.header}>
        <Typography className={classes.title}>
          {i18n.t("settings.webchat.title")}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => handleOpenModal()}
        >
          {i18n.t("settings.webchat.list.newWebChat")}
        </Button>
      </Box>

      <Paper className={classes.paper}>
        <WebChatList
          key={refreshKey}
          onEdit={handleOpenModal}
          onRefresh={handleSave}
        />
      </Paper>

      <WebChatConfigModal
        open={modalOpen}
        onClose={handleCloseModal}
        webChat={selectedWebChat}
        onSave={handleSave}
      />
    </div>
  );
};

export default WebChatSettings;
